import React, { useState } from "react";
import { navigate } from "gatsby";

import Button from "../Button";
import Input from "../Input";
import Select from "../Select";

import * as formStyles from "./FormStyles.module.css";

const ContactForm = ({ props }) => {
  const {
    darkTheme,
    headline,
    headlineLevel,
    instructions,
    redirectOnSuccess,
    redirectTo,
  } = props;

  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [pot, setPot] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [service, setService] = useState("");
  const [company, setCompany] = useState("");
  const [message, setMessage] = useState("");
  // const [optin, setOptin] = useState(true);

  const services = [
    "Content Marketing",
    "Custom Software Development",
    "Digital Advertising",
    "Digital Marketing",
    "Email Marketing",
    "Local SEO",
    "Marketing Automation",
    "Mobile Applications",
    "Search Engine Optimization",
    "Social Media Management & Marketing",
    "Software Development",
    "Software Discovery",
    "Strategy & Consulting",
    "Technical On-Page SEO",
    "UI/UX Design",
    "Video Marketing",
    "Web App Development",
    "Web Design & Development",
    "Workflow Process Automation",
    "Unsure",
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);

    if (pot === "") {
      const response = await fetch(
        "/.netlify/functions/gsheet-lead-submissions",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: name,
            firstName: name.split(" ")[0],
            lastName: name.split(" ")[1],
            email: email,
            phone: phone,
            company: company,
            service: service,
            message: message,
            // optin: optin,
            leadType: "Contact",
            utm_source: localStorage.getItem("utc_source") || "",
            utm_medium: localStorage.getItem("utc_medium") || "",
            utm_content: localStorage.getItem("utc_content") || "",
            utm_campaign: localStorage.getItem("utc_campaign") || "",
          }),
        }
      );

      if (response.status === 200) {
        localStorage.removeItem("utc_source");
        localStorage.removeItem("utc_medium");
        localStorage.removeItem("utc_content");
        localStorage.removeItem("utc_campaign");
        navigate(redirectTo.slug);
      } else {
        setIsProcessing(false);
        setError(true);
        setErrorMessage(
          "There was a problem submitting your message. Please try again."
        );
      }
    } else {
      setError(true);
      setErrorMessage(
        "There was an error submitting the form. Please try again."
      );
    }
  };

  const handleChange = (input, id) => {
    if (id === "pot") {
      setPot(input);
    }
    if (id === "name") {
      setName(input);
    }
    if (id === "email") {
      setEmail(input);
    }
    if (id === "phone") {
      setPhone(input);
    }
    if (id === "company") {
      setCompany(input);
    }
    if (id === "service") {
      setService(input);
    }
    if (id === "message") {
      setMessage(input);
    }
    // if (id === "optin") {
    //   setOptin(!optin);
    // }
  };

  const HeadingTag = headline ? `${headlineLevel}` : "h6";

  return (
    <div
      className={`${formStyles.contactForm} ${
        darkTheme ? formStyles["dark"] : null
      }`}
      // data-aos="zoom-in"
      // data-aos-duration="500"
    >
      {headline && <HeadingTag>{headline}</HeadingTag>}
      {instructions && <p>{instructions}</p>}

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="pot"
          value={pot}
          id="pot"
          style={{ display: "none" }}
        />
        <Input
          id="name"
          label="Name:*"
          type="text"
          variant={darkTheme ? "dark" : "light"}
          name="name"
          value={name}
          handleChange={handleChange}
          required
        />
        <Input
          id="email"
          label="Email:*"
          type="text"
          variant={darkTheme ? "dark" : "light"}
          name="email"
          value={email}
          handleChange={handleChange}
          required
        />
        <Input
          id="phone"
          label="Phone:"
          type="tel"
          variant={darkTheme ? "dark" : "light"}
          name="phone"
          value={phone}
          handleChange={handleChange}
        />

        <Input
          id="company"
          label="Company:"
          type="text"
          variant={darkTheme ? "dark" : "light"}
          name="company"
          value={company}
          handleChange={handleChange}
        />
        <Select
          label="Service of Interest:"
          name="service"
          id="service"
          selected={service}
          options={services}
          handleChange={handleChange}
        />
        <Input
          id="message"
          label="What's on your mind?"
          type="text"
          variant={darkTheme ? "dark" : "light"}
          name="message"
          value={message}
          handleChange={handleChange}
          isTextarea
          required
        />
        {error && <p>{errorMessage}</p>}
        <div className={formStyles.formEnd}>
          <div>
            {/* <Input
              id="optin"
              label="I'm OK with periodical emails from Moonello on Software and Digital Marketing. No spam. Just the goods. Unsubscribe any time."
              type="checkbox"
              variant={darkTheme ? "dark" : "light"}
              name="optin"
              value={message}
              handleChange={handleChange}
              inline
            /> */}
          </div>
          <div>
            <Button disabled={isProcessing} type="submit">
              {isProcessing ? "Sending..." : "Submit"}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ContactForm;
